<ng-template [ngIf]="isLoading">
    <p class="text-muted">
        <i class='fas fa-spinner fa-pulse'></i> Carregando central de compras
    </p>
</ng-template>

<ng-template [ngIf]="isLoaded">
    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label">Central de Compras</label>            
            <input type="text" class="form-control" [value]="centralCompras?.nome" disabled="disabled" readonly="readonly">                           
            <p class="form-text text-muted">
                {{centralCompras?.nomeFantasia}}
            </p>             
        </div>
    </div>
    <div class="row" *ngIf="showParticipantes">
        <div class="col-12">
            <sgt-cliente-central-compra-participante
                [idClienteCentralCompra]="centralCompras?.id"
                [participantes]="centralCompras?.participantes"
                [percParticipacaoTotalCentralCompra]="centralCompras?.percParticipacaoTotal">
            </sgt-cliente-central-compra-participante>                
        </div>
    </div>
</ng-template>

